var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54163 0.799805C1.23936 0.799805 0.166626 1.88356 0.166626 3.19921V15.1962C0.166626 16.5119 1.23936 17.5956 2.54163 17.5956H12.8333V15.996H2.54163C2.09431 15.996 1.74996 15.6481 1.74996 15.1962C1.74996 14.7443 2.09431 14.3964 2.54163 14.3964H4.12496H12.8333V2.39941H4.58728C4.23625 1.51427 3.53645 0.799805 2.54163 0.799805ZM2.54163 2.39941C2.98894 2.39941 3.33329 2.74729 3.33329 3.19921V12.7968H2.54163C2.26308 12.7968 1.99925 12.8559 1.74996 12.9468V3.19921C1.74996 2.74729 2.09431 2.39941 2.54163 2.39941ZM5.70829 4.79881H10.4583V6.39841H5.70829V4.79881ZM5.70829 7.99801H10.4583V9.59761H5.70829V7.99801Z",
    fill: "#555770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyIcon);
export default __webpack_public_path__ + "static/media/agencyIcon.a437529ad344a1ef60e35e9a7c6d31d7.svg";
export { ForwardRef as ReactComponent };